import React from 'react';
import PropTypes from 'prop-types';
import { usePopulate } from 'api/APIHooks';
import CardDataItem from './CardDataItem';

const ClaimsCodes = ({ providedService }) => {
  usePopulate('place_of_service', 'place_of_service', providedService, { queryConfig: { placeholderData: undefined } });
  const placeOfServiceCardData = providedService.place_of_service?.code ?
    [`${providedService.place_of_service?.code} - ${providedService.place_of_service?.description}`] : [];

  usePopulate('zcodes', 'zcodes', providedService, { queryConfig: { placeholderData: undefined } });
  const zcodeCardData = providedService?.zcodes?.map((zcode) => (`${zcode?.code} - ${zcode?.description}`));

  usePopulate('procedure_codes', 'procedure_codes', providedService, { queryConfig: { placeholderData: undefined } });
  const procedureCodeCardData = providedService.procedure_codes.map((pc) => (`${pc?.code} - ${pc?.description}`));

  return (
    <>
      {placeOfServiceCardData?.length > 0 && (
        <CardDataItem
          dataLabel="place-of-services-value"
          label="Place of Service"
          value={placeOfServiceCardData.join(', ')}
        />
      )}
      {zcodeCardData?.length > 0 && (
        <CardDataItem
          dataLabel="zcode-values"
          label="Zcodes"
          value={zcodeCardData.join(', ')}
        />
      )}
      {procedureCodeCardData?.length > 0 && (
        <CardDataItem
          dataLabel="procedure-code-values"
          label="Procedure Codes"
          value={procedureCodeCardData.join(', ')}
        />
      )}
    </>
  );
};

ClaimsCodes.propTypes = {
  providedService: PropTypes.shape({
    place_of_service: PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
    }),
    zcodes: PropTypes.arrayOf(PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
    })),
    procedure_codes: PropTypes.arrayOf(PropTypes.shape({
      code: PropTypes.string,
      description: PropTypes.string,
    })),
  }).isRequired,
};

export default ClaimsCodes;
